
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/training/smartbox",
      function () {
        return require("private-next-pages/training/smartbox.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/training/smartbox"])
      });
    }
  